<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-header bg-primary text-white">
        <h5 class="card-title mb-0">
          <i class="fas fa-file-invoice-dollar me-2"></i>
          DETALLE REPORTE DE ALMACENES DE LA DDE-BENI
        </h5>
      </div>
      
      <div class="card-body">
        <!-- Filtros -->
        <div class="row mb-4">
          <div class="col-md-2">
            <label class="form-label">Gestión</label>
            <select v-model="filtros.gestion" class="form-select form-select-sm">
              <option value="">Todas</option>
              <option v-for="year in opciones.gestiones" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
          </div>
          
          <div class="col-md-3">
            <label class="form-label">Rango de fechas</label>
            <div class="input-group input-group-sm">
              <input v-model="filtros.fecha_inicio" type="date" class="form-control">
              <span class="input-group-text">a</span>
              <input v-model="filtros.fecha_fin" type="date" class="form-control">
            </div>
          </div>
          
          <div class="col-md-2">
            <label class="form-label">Tipo Item</label>
            <select v-model="filtros.categoria_id" class="form-select form-select-sm">
              <option value="valores">Valores</option>
              <option value="consumo">Consumo</option>
            </select>
          </div>
          
          <div class="col-md-3">
            <label class="form-label">Buscar Item</label>
            <div class="input-group input-group-sm">
              <input v-model="filtros.search" type="text" class="form-control" placeholder="Nombre del item...">
              <button @click="aplicarFiltros" class="btn btn-primary" title="Buscar">
                <i class="fas fa-search"></i>
              </button>
              <button @click="limpiarFiltros" class="btn btn-secondary" title="Limpiar">
                <i class="fas fa-undo"></i>
              </button>
            </div>
          </div>
          <div class="col-md-2">
            <label class="form-label">Exportar</label>
            <button @click="exportarPDF" class="btn btn-danger btn-sm w-100" :disabled="cargando || items.length === 0">
              <i class="fas fa-file-pdf me-1"></i> 
              <span v-if="cargando">Generando...</span>
              <span v-else>Exportar PDF</span>
            </button>
          </div>
        </div>
        
        <!-- Resultados -->
        <div v-if="cargando" class="text-center my-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="mt-2">Generando reporte...</p>
        </div>
        
        <div v-else>
          <div v-if="items.length === 0" class="alert alert-info">
            No se encontraron resultados con los filtros aplicados.
          </div>
          
          <div v-else class="table-responsive">
            <table class="table table-sm table-bordered table-striped">
              <thead class="table-dark">
                <tr>
                  <th rowspan="2">Nro.</th>
                  <th rowspan="2">Descripción del Item</th>
                  <th rowspan="2">Unidad</th>
                  <th rowspan="2">Precio Unitario</th>
                  <th colspan="4">Cantidades</th>
                  <th colspan="4">Valores (Bs.)</th>
                </tr>
                <tr>
                  <th>Saldo Inicial</th>
                  <th>Entradas</th>
                  <th>Salidas</th>
                  <th>Saldo Final</th>
                  <th>Saldo Inicial</th>
                  <th>Entradas</th>
                  <th>Salidas</th>
                  <th>Saldo Final</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(categoria, catIndex) in categoriasAgrupadas" :key="categoria.id">
                  <!-- Fila de título de categoría -->
                  <tr class="table-secondary fw-bold">
                    <td colspan="12" class="text-start ps-3">
                      <i class="fas fa-folder-open me-2"></i>
                      {{ categoria.nombre.toUpperCase() }}
                    </td>
                  </tr>
                  
                  <!-- Items de la categoría -->
                  <tr v-for="(item, index) in categoria.items" :key="item.id">
                    <td>{{ itemIndex(catIndex, index) }}</td>
                    <td class="text-start"><span style="font-weight: bold;">{{ item.codigo }}:</span><br> {{ item.nombre_item }}</td>
                    <td>{{ item.unidad_medida }}</td>
                    <td class="text-end">{{ formatoMoneda(item.precio_unitario) }}</td>
                    
                    <!-- Cantidades -->
                    <td class="text-end">{{ item.saldo_inicial }}</td>
                    <td class="text-end">{{ item.entradas }}</td>
                    <td class="text-end">{{ item.salidas }}</td>
                    <td class="text-end">{{ item.saldo_final }}</td>
                    
                    <!-- Valores -->
                    <td class="text-end">{{ formatoMoneda(item.costo_saldo_inicial) }}</td>
                    <td class="text-end">{{ formatoMoneda(item.costo_entradas) }}</td>
                    <td class="text-end">{{ formatoMoneda(item.costo_salidas) }}</td>
                    <td class="text-end">{{ formatoMoneda(item.costo_saldo_final) }}</td>
                  </tr>
                  
                  <!-- Totales por categoría -->
                  <tr class="table-info fw-bold">
                    <td colspan="4" class="text-end">PARCIALES {{ categoria.nombre }}</td>
                    <td class="text-end">{{ categoria.totales.saldo_inicial }}</td>
                    <td class="text-end">{{ categoria.totales.entradas }}</td>
                    <td class="text-end">{{ categoria.totales.salidas }}</td>
                    <td class="text-end">{{ categoria.totales.saldo_final }}</td>
                    <td class="text-end">{{ formatoMoneda(categoria.totales.costo_saldo_inicial) }}</td>
                    <td class="text-end">{{ formatoMoneda(categoria.totales.costo_entradas) }}</td>
                    <td class="text-end">{{ formatoMoneda(categoria.totales.costo_salidas) }}</td>
                    <td class="text-end">{{ formatoMoneda(categoria.totales.costo_saldo_final) }}</td>
                  </tr>
                  
                  <!-- Espacio entre categorías -->
                  <tr v-if="catIndex < categoriasAgrupadas.length - 1">
                    <td colspan="12" style="height: 10px; border: none; background-color: transparent;"></td>
                  </tr>
                </template>
                
                <!-- Totales generales -->
                <tr class="table-success fw-bold" style="border-top: 2px solid #000;">
                  <td colspan="4" class="text-end">TOTAL GENERAL</td>
                  <td class="text-end">{{ totalesGenerales.saldo_inicial }}</td>
                  <td class="text-end">{{ totalesGenerales.entradas }}</td>
                  <td class="text-end">{{ totalesGenerales.salidas }}</td>
                  <td class="text-end">{{ totalesGenerales.saldo_final }}</td>
                  <td class="text-end">{{ formatoMoneda(totalesGenerales.costo_saldo_inicial) }}</td>
                  <td class="text-end">{{ formatoMoneda(totalesGenerales.costo_entradas) }}</td>
                  <td class="text-end">{{ formatoMoneda(totalesGenerales.costo_salidas) }}</td>
                  <td class="text-end">{{ formatoMoneda(totalesGenerales.costo_saldo_final) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, reactive } from 'vue'
import axios from 'axios'

const cargando = ref(false)
const items = ref([])
const categorias = ref([])
const opciones = ref({
  categorias: [],
  gestiones: []
})

// Establecer gestión actual
const gestionActual = new Date().getFullYear().toString()

const filtros = reactive({
  gestion: gestionActual,
  fecha_inicio: '',
  fecha_fin: '',
  categoria_id: 'consumo',
  search: ''
})

// Computed para categorías agrupadas
const categoriasAgrupadas = computed(() => {
  return categorias.value || []
})

// Computed para totales generales
const totalesGenerales = computed(() => {
  return {
    saldo_inicial: categorias.value.reduce((sum, cat) => sum + (cat.totales?.saldo_inicial || 0), 0),
    entradas: categorias.value.reduce((sum, cat) => sum + (cat.totales?.entradas || 0), 0),
    salidas: categorias.value.reduce((sum, cat) => sum + (cat.totales?.salidas || 0), 0),
    saldo_final: categorias.value.reduce((sum, cat) => sum + (cat.totales?.saldo_final || 0), 0),
    costo_saldo_inicial: categorias.value.reduce((sum, cat) => sum + (cat.totales?.costo_saldo_inicial || 0), 0),
    costo_entradas: categorias.value.reduce((sum, cat) => sum + (cat.totales?.costo_entradas || 0), 0),
    costo_salidas: categorias.value.reduce((sum, cat) => sum + (cat.totales?.costo_salidas || 0), 0),
    costo_saldo_final: categorias.value.reduce((sum, cat) => sum + (cat.totales?.costo_saldo_final || 0), 0)
  }
})

// Función para calcular el índice del item dentro de toda la lista
const itemIndex = (catIndex, itemIndex) => {
  let index = 1
  for (let i = 0; i < catIndex; i++) {
    index += (categorias.value[i]?.items?.length || 0)
  }
  return index + itemIndex
}

// Obtener opciones de filtro
const obtenerOpcionesFiltro = async () => {
  try {
    const response = await axios.get('/reportes/almacen/opciones-filtro')
    if (response.data.success) {
      opciones.value = response.data.data
    }
  } catch (error) {
    console.error('Error obteniendo opciones de filtro:', error)
  }
}

// Generar reporte
const generarReporte = async () => {
  try {
    cargando.value = true
    console.log('Generando reporte con filtros:', filtros)
    
    const response = await axios.get('/reportes/almacen', { params: filtros })
    console.log('Respuesta del servidor:', response.data)
    
    if (response.data.success) {
      items.value = response.data.data || []
      categorias.value = response.data.categorias || []
    } else {
      alert('Error: ' + response.data.message)
    }
  } catch (error) {
    console.error('Error generando reporte:', error)
    alert('Error al generar el reporte: ' + (error.response?.data?.message || error.message))
  } finally {
    cargando.value = false
  }
}

// Exportar a PDF
const exportarPDF = async () => {
  if (items.value.length === 0) {
    alert('No hay datos para exportar')
    return
  }
  
  try {
    cargando.value = true
    const params = { ...filtros };
    
    console.log('Exportando PDF con filtros:', params);
    
    const response = await axios.get('/reportes/valores/exportar-pdf', {
      params,
      responseType: 'blob'
    });
    
    // Verificar si la respuesta es un PDF o un JSON de error
    if (response.data.type === 'application/json') {
      // Leer el JSON de error
      const reader = new FileReader();
      reader.onload = function() {
        const errorData = JSON.parse(reader.result);
        alert('Error al generar PDF: ' + errorData.message);
      };
      reader.readAsText(response.data);
      return;
    }
    
    // Crear y descargar el PDF
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `reporte-${filtros.categoria_id}-${new Date().toISOString().split('T')[0]}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
  } catch (error) {
    console.error('Error exporting report to PDF:', error);
    
    // Intentar leer el error si es un blob
    if (error.response?.data instanceof Blob) {
      const reader = new FileReader();
      reader.onload = function() {
        try {
          const errorData = JSON.parse(reader.result);
          alert('Error al generar el PDF: ' + (errorData.message || 'Error desconocido'));
        } catch {
          alert('Error al generar el PDF. Por favor, intente nuevamente.');
        }
      };
      reader.readAsText(error.response.data);
    } else {
      alert('Error al generar el reporte PDF: ' + (error.response?.data?.message || error.message));
    }
  } finally {
    cargando.value = false;
  }
}

// Aplicar filtros
const aplicarFiltros = () => {
  generarReporte()
}

// Limpiar filtros
const limpiarFiltros = () => {
  filtros.gestion = gestionActual
  filtros.fecha_inicio = ''
  filtros.fecha_fin = ''
  filtros.categoria_id = 'consumo'
  filtros.search = ''
  generarReporte()
}

// Formatear moneda
const formatoMoneda = (monto) => {
  if (monto === undefined || monto === null) return 'Bs 0.00'
  return new Intl.NumberFormat('es-BO', {
    style: 'currency',
    currency: 'BOB',
    minimumFractionDigits: 2
  }).format(monto)
}

onMounted(() => {
  obtenerOpcionesFiltro()
  generarReporte()
})
</script>

<style scoped>
.table-responsive {
  max-height: 70vh;
  overflow-y: auto;
  font-size: 0.85rem;
}

.card-title {
  font-size: 1.25rem;
}

.table th {
  font-size: 0.8rem;
  vertical-align: middle;
}

.table td {
  font-size: 0.8rem;
  vertical-align: middle;
}

.table-secondary {
  background-color: #e9ecef !important;
}

.table-info {
  background-color: #d1ecf1 !important;
}

.table-success {
  background-color: #d4edda !important;
  border-top: 2px solid #000;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>